import { render, staticRenderFns } from "./LuckDrawNew.vue?vue&type=template&id=42db5550&scoped=true"
import script from "./LuckDrawNew.vue?vue&type=script&lang=js"
export * from "./LuckDrawNew.vue?vue&type=script&lang=js"
import style0 from "./LuckDrawNew.vue?vue&type=style&index=0&id=42db5550&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42db5550",
  null
  
)

export default component.exports